module.exports = __webpack_public_path__ + "195938d3281456eb5fba5f466911b399.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/gator-clogs-red.png
// module id = 1892
// module chunks = 0